/*
    Merrid Controls. Wszelkie prawa zastrzeżone.
    Plik zawiera kody Źródłowe będące własnością firmy Merrid Controls.
    Nie wolno ich rozpowszechniać w całości lub fragmentach bez wyraźnej zgody właściciela.
*/


/** Import Main React Library Object */
import React from "react";


/** Import Component Children Components */
import MainContentLoaderComponent from "@Components/UI/Loaders/MainContent"; // Content Loader Component


/** @type RestApiRequestLoaderProps - Props List for Main Rest Api Request Loader Component */
type RestApiRequestLoaderProps = {};


/**
 * @visibleName REST API Request Loader Component
 *
 * @return JSX.Element
 */
export const RestApiRequestLoaderComponent: React.FC<RestApiRequestLoaderProps> = (): JSX.Element | null => {


    /**
     * @description render Component Content
     * @return JSX.Element
     */
    return (
        // UI Component - Main Content Loader
        <MainContentLoaderComponent cssClasses={"api-request-loader-component"} />
    );

};


export default RestApiRequestLoaderComponent;
